import {
  ChangeDetectorRef,
  Component,
  ComponentRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

@Component({
  selector: 'lua-panneau-desktop',
  templateUrl: './panneau-desktop.component.html',
  styleUrls: ['./panneau-desktop.component.css'],
})
export class PanneauDesktopComponent implements OnInit {
  @ViewChild('contentContainer', {read: ViewContainerRef, static: true})
  contentContainer!: ViewContainerRef;

  @Input() isMobile = false;
  @Input() title? = '';
  @Input() open = false;
  @Input() secondIconName = '';
  @Input() thirdIconName = '';
  @Output() firstClick = new EventEmitter<Event>();
  @Output() secondClick = new EventEmitter<Event>();
  @Output() panelClosed = new EventEmitter<void>();

  private componentRef: ComponentRef<any> | undefined = undefined;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.checkMobile();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkMobile();
  }

  checkMobile() {
    this.isMobile = window.innerWidth <= 768;
  }

  get closeIconName(): string {
    return this.isMobile ? 'arrow_back' : 'Close';
  }
  openPanel() {
    this.open = true;
    this.cdr.detectChanges();
  }

  closePanel() {
    this.title = '';
    this.destroyComponentRef();
    this.open = false;
    this.panelClosed.emit();
    this.cdr.detectChanges();
  }

  handleClickFirst(event: Event): void {
    this.firstClick.emit(event);
  }
  handleClickSecond(event: Event): void {
    this.secondClick.emit(event);
  }

  setContent(content: Type<any>, inputs: any) {
    this.destroyComponentRef();
    if (this.contentContainer) {
      const componentRef = this.contentContainer.createComponent(content);
      this.componentRef = componentRef;
      Object.assign(componentRef.instance, inputs);
    }
  }

  private destroyComponentRef() {
    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = undefined;
    }
  }
}
